// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";

function PilotClozeDragBucketContainer(props) {
  return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.Drag.make, {
              index: props.index,
              id: props.id,
              children: props.children,
              dragClassName: "PilotClozeDragBucketContainer pilotClozeDragBucketItem"
            });
}

var make = PilotClozeDragBucketContainer;

var $$default = PilotClozeDragBucketContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
